import { Link } from 'gatsby';
import Layout from "../../../../src/components/layout";
import SEO from "../../../../src/components/seo";
import Title from "../../../../src/components/title";
import { Images as images } from "../../../../src/data/assets";
import * as React from 'react';
export default {
  Link,
  Layout,
  SEO,
  Title,
  images,
  React
};